import type { TFunction } from 'react-i18next';
import { PaymentMethodOption } from 'src/modules/associations/models/associationFee';

export enum PaymentMethodEnum {
  None = 0, // Välj aviseringsmetod
  SameFeeForAll = 1, // Alla medlemmar har samma avgift
  MainAndFamily = 2, // Huvudmedlem + familjemedlem
  FamilySteps = 3, // Familjesteg
  OneFeeForHousehold = 4, // En avgift för hela hushållet
  FeeBasedOnProfile = 5, // Avgift baserad på profil
}

export function getPaymentMethodOptions(t: TFunction): PaymentMethodOption[] {
  return [
    // { id: PaymentMethodEnum.None, value: PaymentMethodEnum.None, description: t('association:paymentMethod.none') },
    { id: PaymentMethodEnum.SameFeeForAll, value: PaymentMethodEnum.SameFeeForAll, description: t('association:paymentMethod.sameFeeForAll') },
    { id: PaymentMethodEnum.MainAndFamily, value: PaymentMethodEnum.MainAndFamily, description: t('association:paymentMethod.mainAndFamily') },
    { id: PaymentMethodEnum.FamilySteps, value: PaymentMethodEnum.FamilySteps, description: t('association:paymentMethod.familySteps') },
    {
      id: PaymentMethodEnum.OneFeeForHousehold,
      value: PaymentMethodEnum.OneFeeForHousehold,
      description: t('association:paymentMethod.oneFeeForHousehold'),
    },
    {
      id: PaymentMethodEnum.FeeBasedOnProfile,
      value: PaymentMethodEnum.FeeBasedOnProfile,
      description: t('association:paymentMethod.feeBasedOnProfile'),
    },
  ];
}
